module.exports = __webpack_public_path__ + "img/deyu_paiming_pillar.fa7fddbc.png";